/**
 * possessiveName — English possessive for organization names in UI copy
 * (2026-08-21 owner directive, wallet title): "Prest0 Inc." → "Prest0 Inc.'s",
 * "Law Offices" → "Law Offices'" (a name ending in s takes the bare
 * apostrophe). Typographic apostrophe (U+2019), matching the house copy.
 */
export function possessiveName(name: string): string {
  const trimmed = (name || '').trim();
  if (!trimmed) return '';
  return /s$/i.test(trimmed) ? `${trimmed}’` : `${trimmed}’s`;
}

export default possessiveName;
